import styles from './statsBox.module.scss';
import React, { ReactNode } from 'react';

export default function StatsBox({
    children,
    'data-cy': dataCy
}: {
    children: ReactNode;
    'data-cy'?: string;
}): JSX.Element {
    return (
        <div data-cy={dataCy} className={styles.statsBox}>
            {children}
        </div>
    );
}
